import { render, staticRenderFns } from "./FarmsList.vue?vue&type=template&id=7af355ba&scoped=true&"
import script from "./FarmsList.vue?vue&type=script&lang=js&"
export * from "./FarmsList.vue?vue&type=script&lang=js&"
import style0 from "./FarmsList.vue?vue&type=style&index=0&id=7af355ba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af355ba",
  null
  
)

export default component.exports